import { defineMessages } from "react-intl";

const baseId = "t.components.sidebar.";

export default defineMessages({
  homepage: {
    id: baseId + "list.homepage",
    defaultMessage: "HOME PAGE",
  },
  consoleAdmin: {
    id: baseId + "list.consoleAdmin",
    defaultMessage: "CONSOLE ADMIN",
  },
  requestHistory: {
    id: baseId + "list.requestHistory",
    defaultMessage: "HISTORY REQUEST",
  },
  approvals: {
    id: baseId + "list.approvals",
    defaultMessage: "APPROVALS",
  },
  task: {
    id: baseId + "list.task",
    defaultMessage: "TASK",
  },
  enablingRequest: {
    id: baseId + "list.enablingRequest",
    defaultMessage: "ENABLING REQUEST",
  },
  temporaryAbilitations: {
    id: baseId + "list.temporaryAbilitations",
    defaultMessage: "TEMPORARY ABILITATIONS",
  },
  manuals: {
    id: baseId + "list.manuals",
    defaultMessage: "MANUALS",
  },
  externalPortal: {
    id: baseId + "list.externalPortal",
    defaultMessage: "EXTERNAL PORTAL",
  },
  catalog: {
    id: baseId + "list.catalog",
    defaultMessage: "CATALOG",
  },
  delegates: {
    id: baseId + "list.delegates",
    defaultMessage: "DELEGATES",
  },
  serviceRequest: {
    id: baseId + "list.serviceRequest",
    defaultMessage: "SERVICE REQUEST",
  },
  users: {
    id: baseId + "list.users",
    defaultMessage: "USERS REFERENCE",
  },
  entitlementReference: {
    id: baseId + "list.entitlementReference",
    defaultMessage: "ENTITLEMENT REFERENCE",
  },
  userEntitlements: {
    id: baseId + "list.userEntitlements",
    defaultMessage: "USER ENTITLEMENTS",
  },
  emergencyUsers: {
    id: baseId + "list.emergencyUsers",
    defaultMessage: "EMERGENCY USERS",
  },
  brManagement: {
    id: baseId + "list.brManagement",
    defaultMessage: "BR MANAGEMENT",
  },
  profileManagement: {
    id: baseId + "list.profileManagement",
    defaultMessage: "PROFILE MANAGEMENT",
  },
  resetPassword: {
    id: baseId + "list.resetPassword",
    defaultMessage: "RESET PASSWORD",
  },
  changePassword: {
    id: baseId + "list.changePassword",
    defaultMessage: "CHANGE PASSWORD",
  },
  examineRecertification: {
    id: baseId + "list.examineRecertification",
    defaultMessage: "EXAMINE CAMPAIGN OF RECERTIFICATION",
  },
  createRecertification: {
    id: baseId + "list.createRecertification",
    defaultMessage: "CREATE CAMPAIGN OF RECERTIFICATION",
  },
  report: {
    id: baseId + "list.report",
    defaultMessage: "REPORTS",
  },
  technicalUsers: {
    id: baseId + "list.technicalUsers",
    defaultMessage: "TECHNICAL USERS",
  },
});
